import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(private primengConfig: PrimeNGConfig) { }

    ngOnInit() {
        this.primengConfig.ripple = true;
        // Calendarios, filtros y textos internos de PrimeNG en español
        this.primengConfig.setTranslation({
            dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
            dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
            monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
            firstDayOfWeek: 1,
            today: 'Hoy',
            clear: 'Limpiar',
            weekHeader: 'Sem',
            dateFormat: 'dd/mm/yy',
            accept: 'Sí',
            reject: 'No',
            choose: 'Elegir',
            upload: 'Subir',
            cancel: 'Cancelar',
            apply: 'Aplicar',
            addRule: 'Agregar regla',
            removeRule: 'Quitar regla',
            matchAll: 'Coincidir todas',
            matchAny: 'Coincidir alguna',
            startsWith: 'Empieza con',
            contains: 'Contiene',
            notContains: 'No contiene',
            endsWith: 'Termina con',
            equals: 'Igual a',
            notEquals: 'Distinto de',
            noFilter: 'Sin filtro',
            lt: 'Menor que',
            lte: 'Menor o igual que',
            gt: 'Mayor que',
            gte: 'Mayor o igual que',
            dateIs: 'Fecha igual a',
            dateIsNot: 'Fecha distinta de',
            dateBefore: 'Fecha antes de',
            dateAfter: 'Fecha después de',
            emptyMessage: 'Sin resultados',
            emptyFilterMessage: 'Sin resultados',
            passwordPrompt: 'Escribe una contraseña',
            weak: 'Débil',
            medium: 'Media',
            strong: 'Fuerte',
        });
    }
}
